import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { changedThis } from '../../../reducers/models/company/companyList'
import { useDispatch } from 'react-redux';
import ErrorAdd from '../../../util/ErrorAdd';
import SrvButton from '../../../components/global/SrvButton';

function CompanyList({ list, compnaySelectedId, editHandler }) {

  const dispatch = useDispatch();

  function companyChange(model) {
    dispatch(changedThis());
    axios.post('/api_main/company/select', { ID_Company: model.ID })
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        ErrorAdd(err, window.location.href);
      });
  };

  return (
    <>
      {list.map((item) => (
        <div key={item.ID} className="list_item row mt-15" onClick={() => { editHandler(item.ID) }}>
          <div className="col-md-10">
            <div className='title p-1' >
              {compnaySelectedId === item.ID &&
                <i className="mr-10 text-success"><FontAwesomeIcon icon={faCheck} /></i>
              }
              {item.Name}
            </div>
          </div>
          <div className="col-md-2 d-flex align-items-center justify-content-end">
            {compnaySelectedId !== item.ID &&
              <div> <SrvButton typeBtn="check" loading={false} onClick={(e) => { e.stopPropagation(); companyChange(item) }} /></div>
            }
          </div>
        </div>
      ))}
    </>
  );
}

export default CompanyList;
